var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef, useState, useCallback } from "react";
/**
 * useSimilarListings handles the similarListings data that are lazy loaded
 * @Returns
 * - 'similarListings': The raw array returned by the API for analytics/tracking.
 * - 'similarRecords': A record of similarListings  to be used in the carousel for Card MFE.
 * - 'isDisplayed': 'true' if there is at least one listing to show.
 * - 'isFetched': 'true' after a successful fetch has completed.
 * - 'prefetch(args)': Triggers the fetch.
 * - 'setSimilarListingsData(data)': Imperative setter if you already have data from elsewhere.
 */
export const useSimilarListings = () => {
    const [similarListings, setSimilarListings] = useState([]);
    const [similarRecords, setSimilarRecords] = useState({});
    const [isDisplayed, setIsDisplayed] = useState(false);
    const [isFetched, setIsFetched] = useState(false);
    const requestedForIdRef = useRef({});
    const setSimilarListingsData = useCallback((data) => {
        setSimilarListings(data);
        setSimilarRecords((data !== null && data !== void 0 ? data : [])
            .filter((card) => Object.keys(card).length > 1)
            .reduce((acc, card) => (Object.assign(Object.assign({}, acc), { [card.id]: card })), {}));
        setIsDisplayed(!!(data === null || data === void 0 ? void 0 : data.length));
        setIsFetched(true);
    }, []);
    const prefetch = useCallback((_a) => __awaiter(void 0, [_a], void 0, function* ({ id, url, fetcher }) {
        if (!id || !url)
            return;
        if (requestedForIdRef.current[id] || isFetched)
            return;
        requestedForIdRef.current[id] = true;
        try {
            const data = yield fetcher(url);
            setSimilarListingsData(data);
        }
        catch (e) {
            requestedForIdRef.current[id] = false;
        }
    }), [isFetched, setSimilarListingsData]);
    return {
        similarListings,
        similarRecords,
        isDisplayed,
        isFetched,
        prefetch,
        setSimilarListingsData,
    };
};
